<input type="checkbox" 
	[checked]="globalRecordService.globalRecordIdsHash[data.id]" 
	(change)="toggleRecordId($event)" 
	[attr.aria-label]="'Select ' + data.title" />